import React from 'react';
import brewIcon from "../assets/badge_geo_icon.png";
import badgeGiftIcon from "../assets/badge_gift_icon.png";
import badgeBeerIcon from "../assets/badge_beer_icon.png";
import howItWorks1 from "../assets/how_it_works_1.png";
import howItWorks2 from "../assets/how_it_works_2.png";
import howItWorks3 from "../assets/how_it_works_3.png";
import orangeSection from "../assets/orange_section.svg";

function HowItWorks() {
  const steps = [
    {
      image: howItWorks1,
      badgeIcon: brewIcon,
      title: "Choose a Spot",
      paragraphs: [
        "Browse a curated list of local participating spots near you.",
        "Discover new spots, view menus, check ratings, and pick the perfect place to send a drink from.",
        "Whether it’s your friend’s favorite local spot or a new place they’ve been wanting to try, you’re just a few taps away.",
      ],
    },
    {
      image: howItWorks2,
      badgeIcon: badgeGiftIcon,
      title: "Send a Beer",
      paragraphs: [
        "Select the venue where the recipient can claim your beer, add a personal message, and check out securely in seconds.",
        "Your friend instantly receives a text with a unique QR code, no downloads required to receive the gift.",
      ],
    },
    {
      image: howItWorks3,
      badgeIcon: badgeBeerIcon,
      title: "Cheers!",
      paragraphs: [
        "Your friend visits the location, shows the QR code to the staff, and redeems their beer on the spot.",
        "It’s that simple. No awkward reimbursements, no guessing payments—just good beer and good vibes.",
      ],
    },
  ];

  return (
    <section
      style={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        backgroundColor: "#F9F4EA",
        padding: "clamp(56px, 12vw, 120px) 0",
      }}
    >
      {/* Orange top with curved edge from Figma SVG */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        <img
          src={orangeSection}
          alt=""
          style={{
            width: "100%",
            height: "auto",
            display: "block",
          }}
        />
      </div>
      <div
        style={{
          maxWidth: "1390px",
          margin: "0 auto",
          padding: "0 20px",
          position: "relative",
          zIndex: 1,
        }}
      >
        <h2
          style={{
            textAlign: "center",
            color: "#FFFFFF",
            fontSize: "clamp(32px, 8vw, 60px)",
            fontWeight: "700",
            marginTop: "0px",
            marginBottom: "40px",
          }}
        >
          How It Works
        </h2>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "40px",
          }}
        >
          {steps.map((step, index) => {
            const isReversed = index === 1; // middle card flips image/text like design
            return (
              <div
                key={step.title}
                style={{
                  backgroundColor: "#F9F4EA",
                  borderRadius: "24px",
                  boxShadow: "0 16px 40px rgba(0, 0, 0, 0.2)",
                  padding: "clamp(24px, 6vw, 80px)",
                  display: "flex",
                  flexDirection: isReversed ? "row-reverse" : "row",
                  // Without wrap the 350px image and the text beside it never stack, and
                  // 240px of the 390px screen is padding and gap. AC-MOBILE-F1.
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: "clamp(24px, 6vw, 80px)",
                }}
              >
                <div style={{ flex: "1 1 260px", minWidth: 0, maxWidth: "350px" }}>
                  <div
                    style={{
                      maxWidth: "350px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={step.image}
                      alt={step.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                  </div>
                </div>

                <div
                  style={{
                    flex: "1 1 260px",
                    minWidth: 0,
                    textAlign: "left",
                  }}
                >
                  <img
                    src={step.badgeIcon}
                    alt={step.title}
                    style={{ width: "80px", height: "80px" }}
                  />
                  <h3
                    style={{
                      // Same story as the copy below it: 26px was the phone floor and the card
                      // titles read a size larger than the screen wants. AC-MOBILE-F13.
                      fontSize: "clamp(22px, 5.6vw, 40px)",
                      fontWeight: "700",
                      margin: "0 0 12px",
                      color: "#303030",
                    }}
                  >
                    {step.title}
                  </h3>

                  {step.paragraphs.map((text) => (
                    <p
                      key={text}
                      style={{
                        margin: "0 0 10px",
                        color: "#000000",
                        lineHeight: 1.6,
                        // 24px is the designed desktop measure and stays that from 600px up.
                        // Below it, 24px in a 350px content box is five or six words a line and
                        // the "Cheers!" card alone runs past a full phone screen. AC-MOBILE-F13.
                        fontSize: "clamp(15px, 4vw, 24px)",
                      }}
                    >
                      {text}
                    </p>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
